import { get } from '@/utils/http';
import api from '@/api';

const Msg = {
  state: {
    count: 0, // 消息总数量角标
    msgCount: 0, // 站内信消息数量
    toDoCount: 0, // 待办消息数量
  },
  mutations: {
    // 获取站内信消息数量
    getMsgCount(state) {
      get(api.getMsgCount).then((res) => {
        state.msgCount = res;
        state.count = state.msgCount + state.toDoCount;
      });
    },
    // 获取待办消息数量
    getToDoCount(state) {
      get(api.todoTasks, {
        tenantId: localStorage.getItem('tenantId'),
        accountId: localStorage.getItem('accountId'),
      }).then((res) => {
        state.toDoCount = res.count;
        state.count = state.msgCount + state.toDoCount;
      });
    },
    // 获取最终数量
    setCountNum(state) {
      // 进行数量拼接
      state.count = state.msgCount + state.toDoCount;
    },
  },
};

export default Msg;
